/*
 * File: AsanaTable.tsx
 * Project: a-a
 * File Created: Wednesday, 23rd April 2025 10:18:08 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 7th July 2025 10:36:58 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Box, Chip, LinearProgress, Skeleton, Typography, useTheme } from '@mui/material';
import formatCurrency from '../../../../helper/short-currency';
import zeplinColor from '../../../../theme/Color';
import { Link, useNavigate } from 'react-router-dom';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CustomOverlapImg from '../../../shared/CustomOverlapImg/CustomOverlapImg';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import AsanaAddProject from '../AsanaAddProject/AsanaAddProject';
import { AsanaService } from '../../../../service/asana.service';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import InfiniteScroll from 'react-infinite-scroll-component';

type Projects = {
  Name: string;
  Member: string;
  Teams: string | null;
  Task: string | null;
  Progress: string | null;
};

interface Column {
  id: 'Name' | 'Members' | 'Teams' | 'Task' | 'Progress' | 'Option';
  label: string;
  minWidth?: number;
  align?: 'center';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'Name', label: 'Name', minWidth: 100 },
  { id: 'Members', label: 'Members' },
  {
    id: 'Teams',
    label: 'Teams',

    // align: 'center',
  },
  {
    id: 'Task',
    label: 'Total Task',

    // align: 'center',
  },
  {
    id: 'Progress',
    label: 'Progress',

    // align: 'center',
  },
  {
    id: 'Option',
    label: '',

    // align: 'center',
  },
];

const AsanaTable = ({
  team,
  setCopy,
  getProjects,
  loadingProject,
  setMessage,
  nextStart,
}: {
  team: any[] | undefined;
  setCopy: React.Dispatch<React.SetStateAction<string>>;
  getProjects: (offset?: boolean, add?: boolean) => void;
  loadingProject: boolean;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  nextStart: {
    nextStart: number;
    offset: string | null;
  };
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<HTMLImageElement | null>(null);
  const [link, setLink] = useState('');
  const [selected, setSelected] = useState<any>();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    setAnchorEl(event.target as HTMLImageElement);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleCopyLink = (val: any) => {
    navigator.clipboard.writeText(val);
    setCopy('Copied link');
  };
  const handleClose = () => {
    setCopy('');
  };

  const handleNavigate = (e: any, row: any) => {
    console.log(e.target);
    if (e.target?.alt === 'options-icon') {
      handleClick(e);
    } else if (anchorEl) {
      setAnchorEl(null);
    } else {
      navigate(`${row?.id}`, { state: { selectedProject: row } });
    }
  };
  const handleDeleteClick = async () => {
    try {
      await AsanaService.deleteAsanaProject(selected?.id);
      getProjects(false, true);
    } catch (err) {
      console.log(err);
    }
  };
  const handleDeleteClose = () => {
    setOpenDeleteModal(false);
  };
  return (
    <Paper sx={{ width: '100%', border: 'none', boxShadow: 'none' }}>
      <TableContainer
        sx={
          {
            // overflowY: 'auto',
            // height: '100vh',
            // paddingBottom: '30rem',
            // position: 'relative',
            //   position: 'relative',
            // screenHeight > 1200
            //   ? '74vh'
            //   : screenHeight > 1100
            //   ? '72vh'
            //   : screenHeight > 1000
            //   ? '69vh'
            //   : screenHeight > 900
            //   ? '58vh'
            //   : screenHeight > 800
            //   ? '46vh'
            //   : screenHeight > 700
            //   ? '38vh'
            //   : screenHeight > 600
            //   ? '25vh'
            //   : '15vh',
          }
        }
      >
        <InfiniteScroll
          dataLength={team?.length ? team?.length : 0}
          next={() => {
            // console.log('next', nextStart);
            getProjects(nextStart?.offset ? true : false);
            // next(true);
          }}
          hasMore={nextStart?.offset ? true : false}
          loader={
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <h4></h4>
            </Box>
          }
          height={'calc(100vh - 500px)'}
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            paddingBottom: '1rem',
            // overflowY: 'auto',
          }}
        >
          <Table stickyHeader aria-label='sticky table' sx={{ position: 'relative' }}>
            <TableHead sx={{ zIndex: 1 }}>
              <TableRow
                sx={{
                  // backgroundColor: '#f5f5f5', // Table header background color
                  border: '1px solid black',
                  borderRadius: '14px', // Apply border radius to the table header row
                  '& th': {
                    backgroundColor: '#f5f5f5',
                  },
                  '& th:first-child': {
                    borderRadius: '14px 0px 0px 14px',
                  },
                  '& th:last-child': {
                    borderRadius: '0px 14px 14px 0px',
                  },
                }}
              >
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loadingProject
                ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row, ind) => {
                    return (
                      <TableRow
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={ind}
                        sx={{
                          '&:last-child td, &:last-child th': { borderBottom: '2px solid #ddd' }, // Apply bottom border for each row
                        }}
                        onClick={(e) => handleNavigate(e, row)}
                      >
                        {columns.map((column) => {
                          const value = '';

                          return (
                            <TableCell key={column.id} align={column.align}>
                              {loadingProject ? (
                                <Skeleton
                                  variant='text'
                                  sx={{
                                    fontSize: theme.typography.body2,
                                    flex: 1,
                                    // Optionally adjust other styles here
                                  }}
                                />
                              ) : (
                                ''
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })
                : team?.map((row, ind) => {
                    return (
                      <TableRow
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={ind}
                        sx={{
                          '&:last-child td, &:last-child th': { borderBottom: '2px solid #ddd' }, // Apply bottom border for each row
                        }}
                        onClick={(e) => handleNavigate(e, row)}
                      >
                        {columns.map((column) => {
                          const value =
                            column.id === 'Teams'
                              ? row['team']?.name
                              : row[(column.id as keyof Projects).toLocaleLowerCase()];
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {loadingProject ? (
                                <Skeleton
                                  variant='text'
                                  sx={{
                                    fontSize: theme.typography.body2,
                                    flex: 1,
                                    // Optionally adjust other styles here
                                  }}
                                />
                              ) : column.id === 'Name' ? (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    cursor: 'pointer',
                                  }}
                                  // onClick={() => navigate(row?.AccountId)}
                                >
                                  {/* <Box
                                sx={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '14px',
                                  //   border: '1px solid black',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: zeplinColor.Neutral1,
                                }}
                              > */}
                                  <img
                                    width={'40px'}
                                    height={'40px'}
                                    src={'/assets/deal-blue.png'}
                                    alt='logo'
                                    style={{ objectFit: 'fill' }}
                                  />
                                  {/* <Typography variant='display5' sx={{ color: zeplinColor.Neutral1 }}>
                                  {value
                                    ?.split(' ')
                                    .map((val, index) =>
                                      index === 0 || index === value?.split(' ').length - 1
                                        ? val[0]
                                        : '',
                                    )}
                                </Typography> */}
                                  {/* </Box> */}
                                  {value ?? 0}
                                </Box>
                              ) : column.id === 'Members' ? (
                                <Box>
                                  <CustomOverlapImg
                                    images={row?.members
                                      ?.filter((val: any) => val)
                                      .map((val: any) => val?.photo)}
                                    name={row?.members?.map((val: any) => val?.name)}
                                  />
                                </Box>
                              ) : column.id === 'Task' ? (
                                <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                  <Typography variant='body2' color={zeplinColor.BasicBlack}>
                                    {row?.totalTasks}
                                  </Typography>
                                  {row?.overdue && (
                                    <LightTooltip
                                      title={
                                        <Typography variant='body2' color={zeplinColor.Neutral1}>
                                          {row?.overdues} Task overdue
                                        </Typography>
                                      }
                                      placement='bottom-end'
                                      style={{
                                        backgroundColor: zeplinColor.BasicBlack,
                                        borderRadius: '8px',
                                        padding: '12px',
                                      }}
                                      // sx={{ [`& .${tooltipClasses.tooltip}`]: { backgroundColor: zeplinColor.Neutral1 } }}
                                    >
                                      <img
                                        width={'22px'}
                                        height={'22px'}
                                        src={'/assets/overdue-icon.svg'}
                                        alt='logo'
                                        style={{ objectFit: 'fill' }}
                                      />
                                    </LightTooltip>
                                  )}
                                </Box>
                              ) : column.id === 'Progress' ? (
                                <Box sx={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                  <LinearProgress
                                    variant='determinate'
                                    value={row?.donePercent}
                                    sx={{
                                      flex: 1,
                                      borderRadius: '8px',
                                      height: '8px',
                                      backgroundColor: zeplinColor.Neutral4,
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: zeplinColor.Green4,
                                      },
                                    }}
                                  />
                                  <Typography variant='body3' color={zeplinColor.Neutral9}>
                                    {row?.donePercent}%
                                  </Typography>
                                </Box>
                              ) : column.id === 'Teams' ? (
                                <Box>
                                  <Chip
                                    label={
                                      <Typography
                                        variant='label1'
                                        color={zeplinColor.Neutral1}
                                        sx={{
                                          textAlign: 'center',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {value ?? 'NA'}
                                      </Typography>
                                    }
                                    sx={{
                                      backgroundColor: zeplinColor.BasicBlack,
                                      padding: '5px 12px 5px 12px',
                                      borderRadius: '50px',
                                      // width: '47px',
                                      height: '24px',
                                      '& .MuiChip-label': {
                                        padding: '0px',
                                      },
                                    }}
                                  />
                                </Box>
                              ) : column.format && typeof value === 'number' ? (
                                column.format(value)
                              ) : column.id === 'Option' ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                  <img
                                    width={'22px'}
                                    height={'22px'}
                                    src={'/assets/vertical-dots.svg'}
                                    alt='options-icon'
                                    onClick={(e) => {
                                      handleClick(e);
                                      setLink(row?.projectLink);
                                      setSelected(row);
                                    }}
                                    aria-hidden='false'
                                    // style={{ imageRendering: 'pixelated', filter: 'blur(0px)' }}
                                  />
                                </Box>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              <CustomPopOver
                setAnchorEl={setAnchorEl}
                anchorEl={anchorEl}
                id={id}
                sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    padding: '16px',
                  }}
                >
                  <Link to={`${selected?.id}`} style={{ textDecoration: 'none' }}>
                    <Box sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}>
                      <img src={'/assets/view.svg'} width={18} height={18} />
                      <Typography variant='body3' color={zeplinColor.BasicBlack}>
                        View details
                      </Typography>
                    </Box>
                  </Link>

                  <Box
                    sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                    onClick={() => {
                      setModalOpen(true);
                      setAnchorEl(null);
                    }}
                  >
                    <img src={'/assets/edit.svg'} width={18} height={18} />
                    <Typography variant='body3' color={zeplinColor.BasicBlack}>
                      Edit project
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                    onClick={() => handleCopyLink(selected?.projectLink)}
                  >
                    <img src={'/assets/copy-link.svg'} width={18} height={18} />
                    <Typography variant='body3' color={zeplinColor.BasicBlack}>
                      Copy link
                    </Typography>
                  </Box>

                  <Box
                    sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
                    onClick={(e) => {
                      setOpenDeleteModal(true);
                      setAnchorEl(null);
                    }}
                  >
                    <img src={'/assets/delete-red.png'} width={18} height={18} />
                    <Typography variant='body3' color={zeplinColor.Error}>
                      Delete
                    </Typography>
                  </Box>
                </Box>
              </CustomPopOver>
            </TableBody>
          </Table>
        </InfiniteScroll>
      </TableContainer>

      {selected?.id === selected?.id && (
        <AsanaAddProject
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          data={selected}
          key={selected?.id}
          getProjects={getProjects}
          setMessage={setMessage}
        />
      )}
      <CustomModal handleClose={handleDeleteClose} open={openDeleteModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: '24px',
              backgroundColor: zeplinColor.Neutral1,

              width: '312px',
              // height: '201px',
              boxShadow: 'rgba(0, 0, 0, 0.15)',
              // display: 'flex',
              // flexDirection: 'column',
              // justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '32px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                }}
              >
                <Typography variant='heading3' color={zeplinColor.BasicBlack}>
                  Delete Project
                </Typography>
                <Typography variant='body2' color={zeplinColor.BasicBlack}>
                  Are you sure you want to delete this Project? This action cannot be undone.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: '16px',
                }}
              >
                <Box
                  onClick={() => {
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                  >
                    <Typography variant='buttonMedium' color={zeplinColor.BasicBlack}>
                      Cancel
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={() => {
                    handleDeleteClick();
                    handleDeleteClose();
                  }}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 32px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      // border: `1px solid ${zeplinColor.BasicBlack}`,
                      // width: '312px',
                      // height: '183px',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                      // display: 'flex',
                      // flexDirection: 'column',
                      // justifyContent: 'space-between',
                    }}
                    aria-role='button'
                  >
                    <Typography
                      variant='buttonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Delete
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
          {/* {loading ? <CustomLoader /> : ''} */}
        </Box>
      </CustomModal>
    </Paper>
  );
};

export default AsanaTable;
